import { Emptyable, isNanpCountry, normalizePhoneToE164 } from "@simplyk/common";

export const restoreMissingDialCode = (value: string, iso2Country: string): string | null => {
  if (!isNanpCountry(iso2Country)) {
    return null;
  }

  const digits = value.replace(/\D/g, "");
  const normalized = normalizePhoneToE164(digits, iso2Country);

  if (!normalized) {
    return null;
  }

  const restored = normalized.slice(1);

  return restored === digits ? null : restored;
};

export const toPhoneInputDigits = (stored: Emptyable<string>, iso2Country: Emptyable<string>): string =>
  normalizePhoneToE164(stored ?? null, iso2Country ?? null)?.slice(1) ?? "";
